import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import formData from "../../../components/forms/formsData.json";
import {FormBuilder} from "../../../components/forms/FormBuilder";
import {FormCard} from "../../../components/forms/FormCard";
import {object, string} from "yup";
import BodyHeader from "../../../components/customComp/BodyHeader";
import BodyFooter from "../../../components/customComp/BodyFooter";


const AddNewSite = (props) => {
    const navigate = useNavigate();
    const [entry, setEntry] = useState({});
    const [error, setError] = useState([{}])
    const [isError, setIsError] = useState(false)
    const [currentForm, setCurrentForm] = useState(formData['add_site'])

    const validateSchema = object().shape({
        Site_name: string().required('This field is required'),
        Language_index: string().required('This field is required'),
        Contact_link: string().required('This field is required'),
        Gel_acquisition_link: string().required('This field is required'),
        Website_link: string().required('This field is required'),
        Store_link: string().required('This field is required'),
    })

    useEffect(() => {
        getAllLanguages({}).then(p => {
            currentForm[1]['data'] = p.data.map(item => {
                return {value: item['Language_index'], label: item['Language']}
            })
            setCurrentForm([...currentForm])
        })

    }, [])

    const getAllLanguages = async () => {
        return await props.restApi.getAllLanguages()
    }


    const validateForm = async (currentEntry) => {
        let value = false
        let formErrors = {}
        await validateSchema.validate(currentEntry, {abortEarly: false})
            .then(function (value) {
                setIsError(false)
                setError(formErrors)
            }).catch(function (err) {
                err.inner.forEach(error => {
                    formErrors[error.path] = true
                    let findIndex = currentForm.findIndex(x => x.name === error.path)
                    console.log(error)
                    currentForm[findIndex]['error'] = error.errors
                    console.log(error)
                })
                value = true
                setError(formErrors)
                setIsError(value)
            });
        return value
    }


    const onChange = async (name, value, isNew) => {
        let currentEntry = {...entry}
        if (value === "") {
            value = null
        }
        if (name === "Site" && isNew && value) {
            currentForm[1]['data'].push({label:value.value,value:value.value})
            value=value.value
        }else if(name ==="Site" && value){
            value=value.value
        }
        currentEntry[name] = value
        setEntry({...currentEntry})
        setCurrentForm([...currentForm])

        if (error[name]) {
            await validateForm(currentEntry)
        }
    }

    const createForm = async () => {
        let currentEntry = {...entry}
        let validateEntry = await validateForm(currentEntry)
        if (!validateEntry) {
            let response = await props.restApi.addSite(currentEntry)
            if (response && response.data) {
                navigate(`/${props.rolePath}/Sites`)
            }
        }
    }

    return (
        <div className="w-full px-[3.75rem] py-[3rem]">
            <BodyHeader title={"New Site"} includeButton={false}/>

            <FormCard
                cardMargin={''}
                cardTitle={''}
                data={<FormBuilder
                    data={currentForm}
                    marginSecondRow={"mt-[4.125rem]"}
                    marginFirstRow={"mt-[5.125rem]"}
                    formData={entry}
                    hasCardTitle={true}
                    onChange={e => onChange(e.target.name, e.target.value, e.target.isNew)}
                    containerClassName={""}
                    labelClassName={"font-Poppins text-inputSize font-bold"}
                    inputClassName={"mt-[0.5rem] w-[23rem] rounded-lg h-[3rem] font-Poppins"}
                    isShown={error}
                    isError={isError}
                />}
            />

            <BodyFooter cancelText={"Cancel"}
                        createText={"Create"}
                        marginTop={"mt-[8rem]"}
                        showAlert={true}
                        onCreateClick={() => createForm()}
                        onCancelClick={() => navigate(`/${props.rolePath}/Sites`)}/>


        </div>
    )
}

export default AddNewSite;
